import styles from "./Nav.module.scss";
import { Link } from "react-router-dom";
import { useState, useEffect, useContext } from "react"; // Додано правильні імпорти
import { useCartModal } from "@/context/CartModalContext";
import { CartContext } from "@/context/CartContext"; // Імпорт контексту кошика
import BurgerMenu from "@/components/BurgerMenu/BurgerMenu";

const Nav = () => {
  const { openCart } = useCartModal();
  const { cart } = useContext(CartContext) || { cart: [] }; // Перевірка на undefined для контексту
  const [cartCount, setCartCount] = useState<number>(0); // Стан для кількості товарів

  // Оновлюємо cartCount кожного разу, коли кошик змінюється
  useEffect(() => {
    const totalItems = cart.reduce(
      (acc: number, item: { quantity: number }) => acc + item.quantity,
      0
    );
    setCartCount(totalItems);
  }, [cart]); // Слідкуємо за змінами в кошику
  const [isBurgerOpen, setBurgerOpen] = useState(false);

  return (
    <div className={styles.navSection}>
      <BurgerMenu isOpen={isBurgerOpen} onClose={() => setBurgerOpen(false)} />
      <div className="container">
        <div className={styles.navBlock}>
          <a className={styles.logo} href="/">
            <img src="/images/site-logo.svg" alt="logo" />
          </a>
          <nav className={styles.nav}>
            <div className={styles.firtLink}>
              <div className={styles.linkMenu}>
                <Link to="/">Dienstleistungen</Link>
                <button>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <path
                      d="M1.50002 4L6.00002 8L10.5 4"
                      strokeWidth="1.5"
                      stroke="#4d4d4d"
                    ></path>
                  </svg>
                </button>
              </div>

              <div className={styles.linkSubmenu}>
                <a href="/leistungen-werkstatt-berlin/">
                  Werkstattservice Berlin
                </a>
                <a href="/leistungen-de_at/">Postversand DE&EU</a>
              </div>
            </div>

            <Link to="/shop">Shop</Link>
            <Link to="/uber-uns">Über Uns</Link>
            <Link to="/unsere-partner">Partner</Link>
            <Link to="/karriere">Karriere</Link>
            <Link to="/faq">F.A.Q</Link>
            <Link to="/kontakt">Kontakt</Link>
          </nav>

          <button
            className={styles.burger}
            aria-label="Menu"
            onClick={() => setBurgerOpen(!isBurgerOpen)}
          >
            <span className={styles.bar} />
            <span className={styles.bar} />
            <span className={styles.bar} />
          </button>

          <button className={styles.cart} onClick={openCart}>
            <svg
              className="fill"
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              fill="none"
            >
              <path
                fill="#4d4d4d"
                d="M5.459 4a4 4 0 0 1 3.72 2.531l6.252 15.836a1 1 0 0 0 .93.633h10.23a1 1 0 0 0 .941-.664l3.572-10A1 1 0 0 0 30.162 11H14a1 1 0 1 1 0-2h16.162c2.075 0 3.523 2.055 2.825 4.009l-3.571 10A3 3 0 0 1 26.591 25H16.36a3 3 0 0 1-2.79-1.898L7.318 7.266A2 2 0 0 0 5.46 6H3a1 1 0 0 1 0-2h2.459Z"
              ></path>
              <circle cx="15" cy="29" r="2" fill="#4d4d4d"></circle>
              <circle cx="28" cy="29" r="2" fill="#4d4d4d"></circle>
            </svg>
            {cartCount > 0 && (
              <span className={styles.cartCount}>{cartCount}</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Nav;
